import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import globalEN from './en.json';
import adminCardEN from './adminCard.json';
import aggregatorTableEN from './aggregatorTable.json';
import batchFileDetailsMcEN from './batchFileDetailsMc.json';
import bicctrlEN from './bicctrl.json';
import billOrgCkrEN from './billOrgCkr.json';
import billOrgMkrEN from './billOrgMkr.json';
import billOrgSearchApiEN from './billOrgSearchApi.json';
import blkCbftInstrEN from './blkCbftInstr.json';
import blkCbftInstrCkrEN from './blkCbftInstrCkr.json';
import blkFastInstrEN from './blkFastInstr.json';
import blkFastInstrChkrEN from './blkFastInstrChkr.json';
import blkIbgInstrEN from './blkIbgInstr.json';
import blkIbgInstrChkrEN from './blkIbgInstrChkr.json';
import blkMepsInstrEN from './blkMepsInstr.json';
import blkMepsInstrChkrEN from './blkMepsInstrChkr.json';
import blkMepsInstrCkrEN from './blkMepsInstrCkr.json';
import boHistEN from './boHist.json';
import bulkCbftChkrEN from './bulkCbftChkr.json';
import bulkCbftHistEN from './bulkCbftHist.json';
import bulkCbftMkrEN from './bulkCbftMkr.json';
import bulkCbftMkrHistEN from './bulkCbftMkrHist.json';
import bulkFastChkrEN from './bulkFastChkr.json';
import bulkFastHistEN from './bulkFastHist.json';
import bulkFastMkrEN from './bulkFastMkr.json';
import bulkFastMkrHistEN from './bulkFastMkrHist.json';
import bulkIbgChkrEN from './bulkIbgChkr.json';
import bulkIbgHistEN from './bulkIbgHist.json';
import bulkIbgMkrEN from './bulkIbgMkr.json';
import bulkIbgMkrHistEN from './bulkIbgMkrHist.json';
import bulkMepsChkrEN from './bulkMepsChkr.json';
import bulkMepsHistEN from './bulkMepsHist.json';
import bulkMepsMkrEN from './bulkMepsMkr.json';
import bulkMepsMkrHistEN from './bulkMepsMkrHist.json';
import cardPrefixEN from './cardPrefix.json';
import casaAcctEN from './casaAcct.json';
import commonPrefixEN from './commonPrefix.json';
import consolecmdmenuEN from './consolecmdmenu.json';
import contactEN from './contact.json';
import corporationEN from './corporation.json';
import corpTableDirectoryEN from './corpTableDirectory.json';
import databaseEN from './database.json';
import endPointLogsEN from './endPointLogs.json';
import envApplicationEN from './envApplication.json';
import fldEN from './fld.json';
import grpEN from './grp.json';
import gwConfigEN from './gwConfig.json';
import gwStationProfileEN from './gwStationProfile.json';
import gwStatusEN from './gwStatus.json';
import hlcfBlkViewPymtFileEN from './hlcfBlkViewPymtFile.json';
import hlcfBlkViewPymtFileDtlEN from './hlcfBlkViewPymtFileDtl.json';
import hlcfBlkViewPymtFileIntsrEN from './hlcfBlkViewPymtFileIntsr.json';
import hlcfInqViewPymtFileEN from './hlcfInqViewPymtFile.json';
import hlcfInqViewPymtFileDtlEN from './hlcfInqViewPymtFileDtl.json';
import hlcfInqViewPymtInstrEN from './hlcfInqViewPymtInstr.json';
import inqViewPymtFileEN from './inqViewPymtFile.json';
import interfaceKeyEN from './interfaceKey.json';
import maMerchantEN from './maMerchant.json';
import mandateCkrEN from './mandateCkr.json';
import mandateMkrEN from './mandateMkr.json';
import manMCHistEN from './manMCHist.json';
import matchTypesTableEN from './matchTypesTable.json';
import maTerminalEN from './maTerminal.json';
import menuEN from './menu.json';
import moduleEN from './module.json';
import netsgwTrxnLogEN from './netsgwTrxnLog.json';
import ohBPInstHistoryEN from './ohBPInstHistory.json';
import ohRTInstHistoryEN from './ohRTInstHistory.json';
import onHoldEN from './onHold.json';
import prefixcfgEN from './prefixcfg.json';
import processDirectoryEN from './processDirectory.json';
import responseCodeMapEN from './responseCodeMap.json';
import resubmitBulkMIEN from './resubmitBulkMI.json';
import resubmitFailedChkrFundEN from './resubmitFailedChkrFund.json';
import resubmitFailedChkrFundInstrEN from './resubmitFailedChkrFundInstr.json';
import resubmitFailedFundEN from './resubmitFailedFund.json';
import resubmitFailedFundInstrEN from './resubmitFailedFundInstr.json';
import resubmitFailedHistEN from './resubmitFailedHist.json';
import rlsRjtOnHoldOlnHlcfChnlEN from './rlsRjtOnHoldOlnHlcfChnl.json';
import rlsRjtOnHoldOlnHlcfChnlChkrEN from './rlsRjtOnHoldOlnHlcfChnlChkr.json';
import rlsRjtOnHoldTrxnEN from './rlsRjtOnHoldTrxn.json';
import rlsRjtOnHoldTrxnBtchChkrEN from './rlsRjtOnHoldTrxnBtchChkr.json';
import rlsRjtOnHoldTrxnChkrEN from './rlsRjtOnHoldTrxnChkr.json';
import rlsRjtOnHoldTrxnDtlsEN from './rlsRjtOnHoldTrxnDtls.json';
import rlsRjtOnHoldTrxnDtlsChkrEN from './rlsRjtOnHoldTrxnDtlsChkr.json';
import rlsRjtOnHoldTrxnOnlChkrEN from './rlsRjtOnHoldTrxnOnlChkr.json';
import rlsRjtOnHoldTrxnOnlineEN from './rlsRjtOnHoldTrxnOnline.json';
import roleEN from './role.json';
import roleMenuEN from './roleMenu.json';
import rtCbftEN from './rtCbft.json';
import rtCbftCkrEN from './rtCbftCkr.json';
import rtCbftHistEN from './rtCbftHist.json';
import rtFastEN from './rtFast.json';
import rtFastChkrEN from './rtFastChkr.json';
import rtIaftEN from './rtIaft.json';
import rtIaftChkrEN from './rtIaftChkr.json';
import rtIaftHistEN from './rtIaftHist.json';
import rtMepsEN from './rtMeps.json';
import rtMepsCkrEN from './rtMepsCkr.json';
import screenBlkDtlEN from './screenBlkDtl.json';
import screendtlEN from './screendtl.json';
import secProfileEN from './secProfile.json';
import soDirectDebitEN from './soDirectDebit.json';
import soDirectDebitCkrEN from './soDirectDebitCkr.json';
import soMCHistEN from './soMCHist.json';
import standingOrderEN from './standingOrder.json';
import standingOrderCkrEN from './standingOrderCkr.json';
import tabEN from './tab.json';
import trangrouptableEN from './trangrouptable.json';
import trxnAuthProfileEN from './trxnAuthProfile.json';
import trxnHistEN from './trxnHist.json';
import trxnRouteProfileEN from './trxnRouteProfile.json';
import txnSummaryTblEN from './txnSummaryTbl.json';
import usageLimitProfileEN from './usageLimitProfile.json';
import viewPymtTrxnEN from './viewPymtTrxn.json';
import viewTrxnLogEN from './viewTrxnLog.json';
import WorkListItemEN from './WorkListItem.json';

// Init with only global translations
i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    resources: {
      en: {
        translation: {
          ...globalEN,
          'adminCard': adminCardEN,
          'aggregatorTable': aggregatorTableEN,
          'batchFileDetailsMc': batchFileDetailsMcEN,
          'bicctrl': bicctrlEN,
          'billOrgCkr': billOrgCkrEN,
          'billOrgMkr': billOrgMkrEN,
          'billOrgSearchApi': billOrgSearchApiEN,
          'blkCbftInstr': blkCbftInstrEN,
          'blkCbftInstrCkr': blkCbftInstrCkrEN,
          'blkFastInstr': blkFastInstrEN,
          'blkFastInstrChkr': blkFastInstrChkrEN,
          'blkIbgInstr': blkIbgInstrEN,
          'blkIbgInstrChkr': blkIbgInstrChkrEN,
          'blkMepsInstr': blkMepsInstrEN,
          'blkMepsInstrChkr': blkMepsInstrChkrEN,
          'blkMepsInstrCkr': blkMepsInstrCkrEN,
          'boHist': boHistEN,
          'bulkCbftChkr': bulkCbftChkrEN,
          'bulkCbftHist': bulkCbftHistEN,
          'bulkCbftMkr': bulkCbftMkrEN,
          'bulkCbftMkrHist': bulkCbftMkrHistEN,
          'bulkFastChkr': bulkFastChkrEN,
          'bulkFastHist': bulkFastHistEN,
          'bulkFastMkr': bulkFastMkrEN,
          'bulkFastMkrHist': bulkFastMkrHistEN,
          'bulkIbgChkr': bulkIbgChkrEN,
          'bulkIbgHist': bulkIbgHistEN,
          'bulkIbgMkr': bulkIbgMkrEN,
          'bulkIbgMkrHist': bulkIbgMkrHistEN,
          'bulkMepsChkr': bulkMepsChkrEN,
          'bulkMepsHist': bulkMepsHistEN,
          'bulkMepsMkr': bulkMepsMkrEN,
          'bulkMepsMkrHist': bulkMepsMkrHistEN,
          'cardPrefix': cardPrefixEN,
          'casaAcct': casaAcctEN,
          'commonPrefix': commonPrefixEN,
          'consolecmdmenu': consolecmdmenuEN,
          'contact': contactEN,
          'corporation': corporationEN,
          'corpTableDirectory': corpTableDirectoryEN,
          'database': databaseEN,
          'endPointLogs': endPointLogsEN,
          'envApplication': envApplicationEN,
          'fld-cfg': fldEN,
          'grp-cfg': grpEN,
          'gwConfig': gwConfigEN,
          'gwStationProfile': gwStationProfileEN,
          'gwStatus': gwStatusEN,
          'hlcfBlkViewPymtFile': hlcfBlkViewPymtFileEN,
          'hlcfBlkViewPymtFileDtl': hlcfBlkViewPymtFileDtlEN,
          'hlcfBlkViewPymtFileIntsr': hlcfBlkViewPymtFileIntsrEN,
          'hlcfInqViewPymtFile': hlcfInqViewPymtFileEN,
          'hlcfInqViewPymtFileDtl': hlcfInqViewPymtFileDtlEN,
          'hlcfInqViewPymtInstr': hlcfInqViewPymtInstrEN,
          'inqViewPymtFile': inqViewPymtFileEN,
          'interfaceKey': interfaceKeyEN,
          'maMerchant': maMerchantEN,
          'mandateCkr': mandateCkrEN,
          'mandateMkr': mandateMkrEN,
          'manMCHist': manMCHistEN,
          'matchTypesTable': matchTypesTableEN,
          'maTerminal': maTerminalEN,
          'menu': menuEN,
          'mod-cfg': moduleEN,
          'netsgwTrxnLog': netsgwTrxnLogEN,
          'ohBPInstHistory': ohBPInstHistoryEN,
          'ohRTInstHistory': ohRTInstHistoryEN,
          'onHold': onHoldEN,
          'prefixcfg': prefixcfgEN,
          'processDirectory': processDirectoryEN,
          'responseCodeMap': responseCodeMapEN,
          'resubmitBulkMI': resubmitBulkMIEN,
          'resubmitFailedChkrFund': resubmitFailedChkrFundEN,
          'resubmitFailedChkrFundInstr': resubmitFailedChkrFundInstrEN,
          'resubmitFailedFund': resubmitFailedFundEN,
          'resubmitFailedFundInstr': resubmitFailedFundInstrEN,
          'resubmitFailedHist': resubmitFailedHistEN,
          'rlsRjtOnHoldOlnHlcfChnl': rlsRjtOnHoldOlnHlcfChnlEN,
          'rlsRjtOnHoldOlnHlcfChnlChkr': rlsRjtOnHoldOlnHlcfChnlChkrEN,
          'rlsRjtOnHoldTrxn': rlsRjtOnHoldTrxnEN,
          'rlsRjtOnHoldTrxnBtchChkr': rlsRjtOnHoldTrxnBtchChkrEN,
          'rlsRjtOnHoldTrxnChkr': rlsRjtOnHoldTrxnChkrEN,
          'rlsRjtOnHoldTrxnDtls': rlsRjtOnHoldTrxnDtlsEN,
          'rlsRjtOnHoldTrxnDtlsChkr': rlsRjtOnHoldTrxnDtlsChkrEN,
          'rlsRjtOnHoldTrxnOnlChkr': rlsRjtOnHoldTrxnOnlChkrEN,
          'rlsRjtOnHoldTrxnOnline': rlsRjtOnHoldTrxnOnlineEN,
          'Role': roleEN,
          'RoleMenu': roleMenuEN,
          'rtCbft': rtCbftEN,
          'rtCbftCkr': rtCbftCkrEN,
          'rtCbftHist': rtCbftHistEN,
          'rtFast': rtFastEN,
          'rtFastChkr': rtFastChkrEN,
          'rtIaft': rtIaftEN,
          'rtIaftChkr': rtIaftChkrEN,
          'rtIaftHist': rtIaftHistEN,
          'rtMeps': rtMepsEN,
          'rtMepsCkr': rtMepsCkrEN,
          'screenBlkDtl': screenBlkDtlEN,
          'screendtl': screendtlEN,
          'secProfile': secProfileEN,
          'soDirectDebit': soDirectDebitEN,
          'soDirectDebitCkr': soDirectDebitCkrEN,
          'soMCHist': soMCHistEN,
          'standingOrder': standingOrderEN,
          'standingOrderCkr': standingOrderCkrEN,
          'tab-cfg': tabEN,
          'trangrouptable': trangrouptableEN,
          'trxnAuthProfile': trxnAuthProfileEN,
          'trxnHist': trxnHistEN,
          'trxnRouteProfile': trxnRouteProfileEN,
          'txnSummaryTbl': txnSummaryTblEN,
          'usageLimitProfile': usageLimitProfileEN,
          'viewPymtTrxn': viewPymtTrxnEN,
          'viewTrxnLog': viewTrxnLogEN,
          'WorkListItem': WorkListItemEN
        }
      }
    }
  });

/**
 * Lazy load translations for a module
 * @param {string} namespace - Namespace for the translations (e.g., 'apiConfig')
 * @param {string} path - Path to JSON file (relative to src)
 */
export const loadModuleTranslations = async (namespace, path) => {
  const translations = await import(`${path}`);
  i18n.addResourceBundle(
    'en',
    namespace,
    translations.default || translations,
    true,
    true
  );
};

export default i18n;
